<template>
  <div v-loading="loading">
    <el-table
      v-if="tableConfig"
      :key="tableKey"
      :data="ownCompanies"
      style="width: 100%"
      row-key="id"
    >
      <component
        :is="column.value"
        v-for="column in tableConfig.columns"
        :key="column.value"
      />
      <el-table-column
        fixed="right"
        label=""
        width="130"
        style="text-align: right;"
      >
        <template
          slot="header"
          slot-scope="scope"
        >
          <table-settings
            v-if="tableConfig"
            :config="tableConfig"
            :allcolumns="allColumns"
            :labels="labels"
            store-module="ownCompany"
            :options="['settings']"
          />
        </template>
        <template
          slot-scope="scope"
        >
          <Actions :ownCompany="scope.row" />
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  import Actions from './Actions';
  import TableSettings from '../../TableSettings';
  import columns, { allColumns, labels } from './columns';

  export default {
    components: {
      Actions,
      TableSettings,
      ...columns,
    },
    data() {
      return {
        labels,
        allColumns,
        tableKey: 0,
        currentPage: 1,
        currentSort: {
          prop: 'name',
          order: 'ascending',
        },
      };
    },
    computed: {
      ownCompanies() {
        return this.$store.getters['ownCompany/ownCompanies'];
      },
      tableConfig() {
        return JSON.parse(JSON.stringify(this.$store.getters['ownCompany/tableConfig']));
      },
      loading() {
        return this.$store.getters['ownCompany/loading'];
      },
    },
    watch: {
      tableConfig() {
        this.tableKey++;
      },
    },
    async mounted() {
      await this.$store.dispatch('ownCompany/fetchAll');
    },
  };
</script>


